import type { IRPost } from '../types/ir'

export const IR_SESSION_KEY = 'ir-announcement-session'
export function irHideKey(post: IRPost): string {
  return `ir-hide:${post.slug}:${post.popup?.version ?? 1}`
}

export function isIRAnnouncementActive(post: IRPost, now = Date.now()): boolean {
  return !!post.popup && now >= Date.parse(post.popup.from) && now < Date.parse(post.popup.until)
}

/** UTC+9 midnight; independent of the visitor's timezone. */
export function nextKoreanMidnight(now = Date.now()): number {
  const day = 24 * 60 * 60 * 1000
  const offset = 9 * 60 * 60 * 1000
  return (Math.floor((now + offset) / day) + 1) * day - offset
}
